// Modality pill: Shall and Shall not in brand blue, Should, Should not and May in neutral, always with the word.
import type { Modality } from "@/api/__generated__";
import { Badge } from "@/components/ui/badge";
import { MODALITY_LABELS } from "@/lib/labels";

export function ModalityBadge({ modality, className }: { modality: Modality; className?: string }) {
  const strong = modality === "shall" || modality === "shall_not";
  return (
    <Badge variant={strong ? "brand" : "neutral"} className={className}>
      {MODALITY_LABELS[modality]}
    </Badge>
  );
}
